import { fetchConToken } from '../helpers/fetch';

const MedicosService = {
    especialidadesEfectorP : (IdEfectorP) => {
        return fetchConToken(`EfectoresPEspecialidades/${IdEfectorP}`)
    },
    cmEfectorP : (IdEfectorP) => {
        return fetchConToken(`EfectoresPCentrosMedicos/${IdEfectorP}`)
    },
    setCM : (data) => {
        return fetchConToken(`EfectoresPCentrosMedicos`, data, "POST")
    },
    deleteCM : (data) => {
        return fetchConToken(`EfectoresPCentrosMedicos`, data, "DELETE")
    },
    setEspecialidad : (data) => {
        return fetchConToken(`EfectoresPEspecialidades`, data, "POST")
    },
    deleteEspecialidad : (data) => {
        return fetchConToken(`EfectoresPEspecialidades`, data, "DELETE")
    }
}

export {MedicosService as default}